import { Dialog, Transition } from '@headlessui/react'
import { Fragment } from 'react'
import { SideBarV2 } from 'app/components/sidebar/SideBarV2'

interface ModalProps {
  open: boolean
  children: React.ReactElement
  onClose: () => void
}

export default function SideBarModal({ open, children, onClose }: ModalProps): React.ReactElement {
  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="dialog relative p-5" onClose={onClose}>
        <div className="fixed inset-0 z-20">
          <div className="flex items-end justify-center text-center sm:items-center sm:p-0">
            <Dialog.Panel className="flex h-screen flex-col bg-surface text-left transition-all sm:w-full">
              <div className="relative flex grow overflow-hidden">
                <SideBarV2 />
                <main className="flex h-full flex-1 flex-col overflow-hidden bg-surface pt-8">{children}</main>
              </div>
            </Dialog.Panel>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
